













import { defineComponent, ref, onMounted } from '@vue/composition-api';
import ViewContainer from '@/components/ViewContainer.vue';
import { messenger } from '../messenger';
import { HammerJsAdapter, TapGesture, PanGesture, PressGesture, PinchPanRotateGesture } from '../prototyping/pointer-input';

export default defineComponent({
  name: 'HammerInput',
  components: {
    ViewContainer,
  },
  setup() {
    const rootRef = ref<HTMLDivElement | null>(null);
    const input = messenger.unity?.input;
    const hm = ref<HammerJsAdapter | null>(null);

    function onTap(e: CustomEvent<TapGesture>) {
      if (process.env.NODE_ENV !== 'production') console.log(e.detail);
      if (input) input.sendTap(e.detail);
    }

    function onPan(e: CustomEvent<PanGesture>) {
      if (process.env.NODE_ENV !== 'production') console.log(e.detail);
      if (input) input.sendPan(e.detail);
    }

    function onPinchPanRotate(e: CustomEvent<PinchPanRotateGesture>) {
      if (process.env.NODE_ENV !== 'production') console.log(e.detail);
      if (input) input.sendPinchPanRotate(e.detail);
    }

    function onPress(e: CustomEvent<PressGesture>) {
      if (process.env.NODE_ENV !== 'production') console.log(e.detail);
      if (input) input.sendPress(e.detail);
    }

    onMounted(() => {
      if (rootRef.value) hm.value = new HammerJsAdapter(rootRef.value);
    });

    return {
      rootRef,
      onTap,
      onPan,
      onPinchPanRotate,
      onPress,
      hm,
    };
  },
});
